import { AxiosResponse } from 'axios'
import { acceptHMRUpdate, defineStore } from 'pinia'

import api from '@/lib/api'

import { ApiCurrentInventory, ApiPagination } from '@/types'

type State = {
  currentInventoryData: ApiCurrentInventory[]
  pagination: {
    totalPages: number
  }
}

type Actions = {
  getCurrentInventory: (filters: {
    currentPage: number
    pageSize: number
    searchTerm: string
  }) => Promise<ApiPagination>
  editCurrentInventory: (currentInventoryData: {
    departmentId: number
    inventoryId: number
    quantity: number
  }) => Promise<void>
  downloadCurrentInventory: (searchTerm: string) => Promise<AxiosResponse<BlobPart, unknown>>
  resetState: () => void
}
export const useCurrentInventoryStore = defineStore<string, State, Record<string, never>, Actions>(
  'current-inventory',
  {
    state: () => ({
      currentInventoryData: [],
      pagination: {
        totalPages: 0,
      },
    }),

    actions: {
      async getCurrentInventory(filters) {
        const response = await api.inventoryTracking.getCurrentInventory(filters)
        this.currentInventoryData = response.data.currentInventory
        return response.data.pagination
      },

      async editCurrentInventory(currentInventoryData) {
        await api.inventoryTracking.editCurrentInventory(currentInventoryData)
      },

      async downloadCurrentInventory(searchTerm) {
        const response = await api.inventoryTracking.downloadCurrentInventory(searchTerm)
        return response
      },

      resetState() {
        this.$reset()
      },
    },
  },
)

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCurrentInventoryStore, import.meta.hot))
}
